// removed by extract-text-webpack-plugin
module.exports = {"wrap":"_3vxuh-pj7I6iLhgw_GL37c_0","header":"_2E6UK9153tf8Eg-AG97Wbv_0","main_contain":"_34xHzbCPWW2AuKe4zUiCuY_0","main":"_1HcH3dfiW_fQAIQMjYw828_0","footer":"_2jmM-Pkkz2emV15k-xVTsi_0","router":"_3tP_PZ186riIUWk5mhrm5T_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-266666f6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = SUi7
// module chunks = 4